
import React from 'react';
import { PersonSearch } from '@mui/icons-material';
import { MdLibraryBooks } from 'react-icons/md';
import { FaFileAlt } from 'react-icons/fa';
import { getMoneyMask, toBrazilianDate } from '../../helpers';
import TableHeader from '../../models/TableHeader';
import CheckboxField from '../../components/UI/Field/Checkbox/CheckboxField';
import TooltipUI from '../../components/UI/Tooltip/Tooltip';
import { blackTwo, lightGrey } from '../../helpers/constants/colors.constants';
import { TableActionButton, TableActionContainer } from '../../components/UI/Tabela/tableDefaultStyles';

class ValidarProcessoFactory {
  makeCabecalhoTabela(
    changeSelectAll = () => { }, selectAll = false,
  ) {
    return [
      new TableHeader({
        id: 'idProcessoValidar',
        checkbox: true,
        label: (
          <CheckboxField
            checked={selectAll}
            onChange={changeSelectAll}
          />
        ),
        alignCell: 'left',
        maxWidth: 39,
      }),
      new TableHeader({
        id: 'idProcesso',
        label: 'Processo',
        alignCell: 'center',
        maxWidth: '10%',
      }),
      new TableHeader({
        id: 'nomeCliente',
        label: 'Cliente',
        alignCell: 'center',
        maxWidth: '10%',
      }),
      new TableHeader({
        id: 'nomeDevedor',
        label: 'Devedor',
        alignCell: 'center',
        maxWidth: '10%',
      }),
      new TableHeader({
        id: 'hasCnpjCpfDevedor',
        label: 'CNPJ/CPF',
        alignCell: 'center',
        maxWidth: '10%',
      }),

      new TableHeader({
        id: 'hasEmailDevedor',
        label: 'Email',
        alignCell: 'center',
        maxWidth: '10%',
      }),
      new TableHeader({
        id: 'hasTelefoneDevedor',
        label: 'Telefone',
        alignCell: 'center',
        maxWidth: '10%',
      }),
      new TableHeader({
        id: 'valorProcesso',
        label: 'Valor',
        alignCell: 'left',
        maxWidth: '10%',
      }),
      new TableHeader({
        id: 'antecedente',
        label: 'Antecedente',
        alignCell: 'center',
        maxWidth: '5%',
      }),
      new TableHeader({
        id: 'whatsApp',
        label: 'WhatsApp',
        alignCell: 'center',
        maxWidth: '5%',
      }),
      new TableHeader({
        id: 'dataConsulta',
        label: 'Consulta',
        alignCell: 'center',
        maxWidth: '5%',
      }),
      new TableHeader({
        id: 'acoes',
        label: 'Ações',
        alignCell: 'center',
        maxWidth: '5%',
      }),
    ];
  }

  makeConteudoTabela(validarProcessos, changeSelectId, listIds, goToInspecaoProcesso, goToDevedorProcesso, goToAntecedentesProcesso) {
    if (!validarProcessos || validarProcessos.length === 0) {
      return [];
    }

    return validarProcessos.map(validarProcesso => ({
      id: validarProcesso.idProcesso,
      values: {
        idProcessoValidar: <CheckboxField
          name={String(validarProcesso.idProcesso)}
          checked={listIds[validarProcesso.idProcesso] || false}
          onChange={changeSelectId}
        />,
        idProcesso: validarProcesso.idProcesso,
        nomeCliente: validarProcesso.nomeCliente,
        nomeDevedor: validarProcesso.nomeDevedor,
        cnpjCpfDevedor: validarProcesso.cnpjCpfDevedor,
        emailDevedor: validarProcesso.emailDevedor,
        telefoneDevedor: validarProcesso.telefoneDevedor,
        valorProcesso: getMoneyMask(validarProcesso.valorProcesso),
        antecedente: validarProcesso.antecedente,
        whatsApp: validarProcesso.whatsApp,
        dataConsulta: toBrazilianDate(validarProcesso.dataConsulta),
        hasCnpjCpfDevedor: validarProcesso.cnpjCpfDevedor ? 'Sim' : 'Não',
        hasEmailDevedor: validarProcesso.emailDevedor ? 'Sim' : 'Não',
        hasTelefoneDevedor: validarProcesso.telefoneDevedor ? 'Sim' : 'Não',
        acoes: (
          <div>
            <TableActionContainer>
              <TooltipUI title="Alterar Dados do Devedor" placement="bottom">
                <TableActionButton
                  onClick={() => { goToDevedorProcesso(validarProcesso.idProcesso); }}
                >
                  <PersonSearch size={20} color={blackTwo} />
                </TableActionButton>
              </TooltipUI>
              <TooltipUI title="Consultar Antecedentes" placement="bottom">
                <TableActionButton
                  disabled={validarProcesso.antecedente === 'Não'}
                  onClick={() => { goToAntecedentesProcesso(validarProcesso.idProcesso); }}
                >
                  <MdLibraryBooks size={20} color={validarProcesso.antecedente === 'Não' ? lightGrey : blackTwo} />
                </TableActionButton>
              </TooltipUI>
              <TooltipUI title="Consultar Processo" placement="bottom">
                <TableActionButton
                  onClick={() => { goToInspecaoProcesso(validarProcesso.idProcesso); }}
                >
                  <FaFileAlt size={20} color={blackTwo} />
                </TableActionButton>
              </TooltipUI>
            </TableActionContainer>
          </div>
        ),
      },
    }));
  }
}

export const validarProcessoFactory = new ValidarProcessoFactory();
